var map = {
	"./press-releases.de-CH.json": 1468,
	"./press-releases.de-DE.json": 1469,
	"./press-releases.en-CA.json": 1470,
	"./press-releases.en-GB.json": 1471,
	"./press-releases.en-IN.json": 1472,
	"./press-releases.en-ME.json": 1473,
	"./press-releases.en-US.json": 1474,
	"./press-releases.es-EM.json": 1475,
	"./press-releases.es-ES.json": 1476,
	"./press-releases.fr-BE.json": 1477,
	"./press-releases.fr-CA.json": 1478,
	"./press-releases.fr-CH.json": 1479,
	"./press-releases.nl-BE.json": 1480,
	"./press-releases.nl-NL.json": 1481,
	"./press-releases.pl-PL.json": 1482,
	"./press-releases.pt-BR.json": 1483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1467;